import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ExternalProviderRepository,
  SubmitEvaluationBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface SubmitEvaluationCommand {
  participationId: string;
  body: SubmitEvaluationBody;
  externalProviderRepository: ExternalProviderRepository;
}

export const submitExternalProviderEvaluation = createAsyncThunk<void, SubmitEvaluationCommand>(
  "externalProvider/submitEvaluation",
  async ({ participationId, body, externalProviderRepository }: SubmitEvaluationCommand) => {
    return externalProviderRepository.submitEvaluation(participationId, body);
  },
);

export const resetSubmitExternalProviderEvaluation = createAction("externalProvider/resetSubmitEvaluation");
